const rolesColorPalette = [
  '#007f59',
  '#004b6a',
  '#012570',
  '#586ea1',
  '#00c384',
  '#ff8b00',
  '#9d0000',
];

export const getAvatarBg = () => {
  return rolesColorPalette[
    Math.floor(Math.random() * rolesColorPalette.length)
  ];
};
